import React, { useState, useEffect } from 'react'
import { Button, Input } from '@byscott-io/corebyscott'
import Lex from '../Shared/Lex'

const ProfileInfo = ({ userStore }) => {
  const user = userStore.user
  const [firstName, setFirstName] = useState(user?.firstName || user?.first_name || '')
  const [lastName, setLastName] = useState(user?.lastName || user?.last_name || '')
  const [nickname, setNickname] = useState(user?.nickname || '')
  const [email, setEmail] = useState(user?.email || '')

  // Update form fields when user data loads
  useEffect(() => {
    if (user) {
      setFirstName(user.firstName || user.first_name || '')
      setLastName(user.lastName || user.last_name || '')
      setNickname(user.nickname || '')
      setEmail(user.email || '')
    }
  }, [user])

  let firstNameField = null

  useEffect(() => {
    if (firstNameField) firstNameField.focus()
  }, [])

  const save = () => {
    userStore.updateUser(user, firstName, lastName, nickname, email)
  }

  return (
    <div className="profile-info-section cbs-scope">
      <h3><Lex term="profile-information" /></h3>
      <table className="center p10">
        <tbody>
          <tr>
            <th className="text-right"><Lex term="first-name" /></th>
            <td><Input innerRef={el => { firstNameField = el }} value={firstName} onChange={(el) => setFirstName(el.target.value)} /></td>
          </tr>
          <tr>
            <th className="text-right"><Lex term="last-name" /></th>
            <td><Input value={lastName} onChange={(el) => setLastName(el.target.value)} /></td>
          </tr>
          <tr>
            <th className="text-right"><Lex term="nickname" /></th>
            <td><Input value={nickname} onChange={(el) => setNickname(el.target.value)} /></td>
          </tr>
          <tr>
            <th className="text-right"><Lex term="email" /></th>
            <td><Input value={email} onChange={(el) => setEmail(el.target.value)} /></td>
          </tr>
          <tr>
            <th className="text-right" />
            <td><Button onClick={save} color="success"><Lex term="save" /></Button></td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

export default ProfileInfo